import { Children, cloneElement, isValidElement, useCallback } from 'react';
import { Modal, ModalDialog } from '@mui/joy';

export default function ModalMessagePane({ children, modalMessage, setModalMessage }) {
  const close = useCallback(() => {
    setModalMessage((previous) => ({ ...previous, open: false }));
  }, [setModalMessage]);
  return (
    <Modal open={Boolean(modalMessage.open)} onClose={close}
      sx={{ zIndex: 10012 }}
      slotProps={{ backdrop: { sx: { bgcolor: 'rgba(20, 22, 35, 0.38)', backdropFilter: 'blur(3px)' } } }}>
      <ModalDialog layout="center" aria-label="Чат"
        sx={{
          p: 0, gap: 0, overflow: 'hidden', border: '1px solid', borderColor: 'divider',
          bgcolor: 'background.surface', boxShadow: '0 24px 80px rgba(25, 28, 45, 0.22)',
          width: { xs: '100vw', sm: 'min(820px, calc(100vw - 48px))' },
          height: { xs: '100dvh', sm: 'min(88dvh, 900px)' },
          maxWidth: 'none', maxHeight: 'none', minHeight: 0,
          borderRadius: { xs: 0, sm: '24px' },
          top: { xs: 0, sm: '50%' }, left: { xs: 0, sm: '50%' },
          transform: { xs: 'none', sm: 'translate(-50%, -50%)' },
        }}>
        {Children.map(children, (child) => isValidElement(child)
          ? cloneElement(child, { heightOverride: '100%', onCloseChat: close }) : child)}
      </ModalDialog>
    </Modal>
  );
}